import filter from './filter.js';

// Trim out all falsy values from an array.
export default function compact(array) {
  return filter(array, Boolean);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/compact.js
// module id = 384
// module chunks = 0 1